class SidebarMenuManager {
  constructor() {
    this.isMobile = false;
    this.slideStack = [];
    this.fourthLevelData = new Map();
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.checkMobileState();
      this.parseFourthLevelMenuData();
      this.setupSidebarMenus();
      this.setupResizeHandler();
    });
  }

  checkMobileState() {
    this.isMobile = window.innerWidth < 768;
  }

  parseFourthLevelMenuData() {
    const fourthLevelScripts = document.querySelectorAll('.fourth-level-menu-data');
    fourthLevelScripts.forEach(script => {
      try {
        const data = JSON.parse(script.textContent);
        if (data.menuHandle && data.links) {
          this.fourthLevelData.set(data.menuHandle, data.links);
        }
      } catch (e) {
        console.warn('Failed to parse fourth level menu data:', e);
      }
    });
  }

  setupSidebarMenus() {
    if (this.isMobile) {
      this.setupMobileSlideNavigation();
    } else {
      this.resetToDefaultMobile();
      this.setupDesktopNavigation();
    }
  }

  setupMobileSlideNavigation() {
    const dropdownMenus = document.querySelectorAll('.main-nav__child:not(.mega-nav)');
    
    dropdownMenus.forEach(dropdown => {
      this.initializeMobileSlideMenu(dropdown);
    });
  }

  initializeMobileSlideMenu(dropdown) {
    const existingSlideContainer = dropdown.querySelector('.mobile-slide-container');
    if (existingSlideContainer) {
      existingSlideContainer.remove();
    }

    const slideContainer = document.createElement('div');
    slideContainer.className = 'mobile-slide-container';
    
    const childNav = dropdown.querySelector('.child-nav');
    if (!childNav) return;

    const mainSlide = document.createElement('div');
    mainSlide.className = 'mobile-slide active';
    mainSlide.appendChild(childNav.cloneNode(true));
    
    slideContainer.appendChild(mainSlide);
    
    childNav.parentNode.replaceChild(slideContainer, childNav);
    
    this.setupMobileSlideEvents(dropdown, slideContainer);
  }

  setupMobileSlideEvents(dropdown, slideContainer) {
    const categoryItems = slideContainer.querySelectorAll('.child-nav > li:nth-child(n+3)');
    
    categoryItems.forEach(item => {
      const navMenu = item.querySelector('nav-menu');
      const toggle = item.querySelector('.child-nav__item--toggle');
      
      if (navMenu && toggle) {
        const panel = navMenu.querySelector('.disclosure__panel');
        const grandchildList = panel ? panel.querySelector('.main-nav__grandchild') : null;
        
        if (grandchildList && grandchildList.children.length > 0) {
          toggle.removeEventListener('click', this.handleMobileSlideClickBound);
          
          this.handleMobileSlideClickBound = (e) => {
            this.handleMobileSlideClick(e, toggle, slideContainer, panel);
          };
          
          toggle.addEventListener('click', this.handleMobileSlideClickBound);
          
          const details = navMenu.querySelector('details');
          if (details) {
            details.addEventListener('click', (e) => e.preventDefault());
          }
        }
      }
    });
  }

  handleMobileSlideClick(e, toggle, slideContainer, panel) {
    e.preventDefault();
    e.stopPropagation();
    
    if (!this.isMobile) return;
    
    const categoryTitle = this.getCategoryName(toggle);
    const grandchildList = panel.querySelector('.main-nav__grandchild');
    
    if (!grandchildList || grandchildList.children.length === 0) {
      const categoryUrl = toggle.getAttribute('data-category-url');
      if (categoryUrl) {
        window.location.href = categoryUrl;
      }
      return;
    }
    
    this.createAndShowSubSlide(slideContainer, categoryTitle, panel, toggle);
  }

  createAndShowSubSlide(slideContainer, categoryTitle, panel, parentToggle) {
    const newSlide = document.createElement('div');
    newSlide.className = 'mobile-slide';
    
    const header = document.createElement('ul');
    header.className = 'child-nav mobile-slide-nav';
    
    const backItem = document.createElement('li');
    const backButton = document.createElement('button');
    backButton.type = 'button';
    backButton.className = 'main-nav__item main-nav__item--back mobile-slide-back';
    backButton.innerHTML = `
      <div class="main-nav__item-content text-start">
        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="m14.307 4.5-7.5 7.5 7.5 7.5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>
        Back
      </div>
    `;
    backItem.appendChild(backButton);
    header.appendChild(backItem);
    
    const titleItem = document.createElement('li');
    titleItem.innerHTML = `
      <a href="#" class="main-nav__item child-nav__item large-text main-nav__item-header">
        ${categoryTitle}
      </a>
    `;
    header.appendChild(titleItem);
    
    const grandchildList = panel.querySelector('.main-nav__grandchild');
    if (grandchildList) {
      const subItems = Array.from(grandchildList.children);
      subItems.forEach(subItem => {
        const li = document.createElement('li');
        
        // Check if this item has fourth level menu
        const subItemToggle = subItem.querySelector('.grandchild-nav__item--toggle');
        const hasFourthLevel = subItemToggle && subItemToggle.getAttribute('data-has-fourth-level') === 'true';
        
        if (hasFourthLevel && this.isMobile) {
          const menuHandle = subItemToggle.getAttribute('data-menu-handle');
          const fourthLevelLinks = this.fourthLevelData.get(menuHandle);
          
          if (fourthLevelLinks && fourthLevelLinks.length > 0) {
            // Create clickable item that will open fourth level
            const fourthLevelToggle = subItem.cloneNode(true);
            const toggleElement = fourthLevelToggle.querySelector('.grandchild-nav__item--toggle');
            
            if (toggleElement) {
              toggleElement.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.createAndShowFourthLevelSlide(slideContainer, subItem, fourthLevelLinks, menuHandle);
              });
              
              // Add visual indicator for fourth level by cloning chevron-right icon
              const existingChevronRight = document.querySelector('.main-nav__item--go .icon, .main-nav__icon-circle .icon');
              if (existingChevronRight) {
                const chevronRight = existingChevronRight.cloneNode(true);
                chevronRight.classList.add('fourth-level-indicator');
                toggleElement.appendChild(chevronRight);
              } else {
                // Fallback: create chevron-right if not found
                const chevronRight = document.createElement('span');
                chevronRight.className = 'fourth-level-indicator icon';
                chevronRight.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="m9.693 4.5 7.5 7.5-7.5 7.5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>`;
                toggleElement.appendChild(chevronRight);
              }
            }
            
            li.appendChild(fourthLevelToggle);
          } else {
            li.appendChild(subItem.cloneNode(true));
          }
        } else {
          li.appendChild(subItem.cloneNode(true));
        }
        
        header.appendChild(li);
      });
    }
    
    newSlide.appendChild(header);
    slideContainer.appendChild(newSlide);
    
    this.slideToNext(slideContainer, newSlide);
    
    const backButton2 = newSlide.querySelector('.mobile-slide-back');
    if (backButton2) {
      backButton2.addEventListener('click', () => {
        this.slideToPrevious(slideContainer, newSlide);
      });
    }
  }

  createAndShowFourthLevelSlide(slideContainer, parentItem, fourthLevelLinks, menuHandle) {
    if (!this.isMobile) return;
    
    const newSlide = document.createElement('div');
    newSlide.className = 'mobile-slide fourth-level-slide';
    
    const header = document.createElement('ul');
    header.className = 'child-nav mobile-slide-nav fourth-level-nav';
    
    // Back button
    const backItem = document.createElement('li');
    const backButton = document.createElement('button');
    backButton.type = 'type';
    backButton.className = 'main-nav__item main-nav__item--back mobile-slide-back';
    backButton.innerHTML = `
      <div class="main-nav__item-content text-start">
        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="m14.307 4.5-7.5 7.5 7.5 7.5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>
        Back
      </div>
    `;
    backItem.appendChild(backButton);
    header.appendChild(backItem);
    
    // Category title
    const parentTitle = parentItem.querySelector('.grandchild-nav__item')?.textContent?.trim() || 'Subcategory';
    const titleItem = document.createElement('li');
    titleItem.innerHTML = `
      <a href="#" class="main-nav__item child-nav__item large-text main-nav__item-header">
        ${parentTitle}
      </a>
    `;
    header.appendChild(titleItem);
    
    // Fourth level links
    fourthLevelLinks.forEach(link => {
      const li = document.createElement('li');
      li.className = 'fourth-level-item';
      li.innerHTML = `
        <div class="grandchild-nav__item--toggle flex items-center">
          <a class="main-nav__item fourth-level-nav__item" href="${link.url}">
            ${link.title}
          </a>
        </div>
      `;
      header.appendChild(li);
    });
    
    newSlide.appendChild(header);
    slideContainer.appendChild(newSlide);
    
    this.slideToNext(slideContainer, newSlide);
    
    const backButton2 = newSlide.querySelector('.mobile-slide-back');
    if (backButton2) {
      backButton2.addEventListener('click', () => {
        this.slideToPrevious(slideContainer, newSlide);
      });
    }
  }

  slideToNext(slideContainer, newSlide) {
    const currentSlide = slideContainer.querySelector('.mobile-slide.active');
    
    newSlide.style.transform = 'translateX(100%)';
    
    requestAnimationFrame(() => {
      currentSlide.style.transform = 'translateX(-100%)';
      newSlide.style.transform = 'translateX(0)';
      
      currentSlide.classList.remove('active');
      newSlide.classList.add('active');
    });
    
    this.slideStack.push(currentSlide);
  }

  slideToPrevious(slideContainer, currentSlide) {
    if (this.slideStack.length === 0) return;
    
    const previousSlide = this.slideStack.pop();
    
    previousSlide.style.transform = 'translateX(-100%)';
    
    requestAnimationFrame(() => {
      currentSlide.style.transform = 'translateX(100%)';
      previousSlide.style.transform = 'translateX(0)';
      
      currentSlide.classList.remove('active');
      previousSlide.classList.add('active');
      
      setTimeout(() => {
        if (slideContainer.contains(currentSlide)) {
          slideContainer.removeChild(currentSlide);
        }
      }, 300);
    });
  }

  setupDesktopNavigation() {
    const dropdownMenus = document.querySelectorAll('.main-nav__child:not(.mega-nav)');
    
    dropdownMenus.forEach(dropdown => {
      this.initializeDesktopDropdown(dropdown);
    });
  }

  resetToDefaultMobile() {
    const dropdownMenus = document.querySelectorAll('.main-nav__child:not(.mega-nav)');
    
    dropdownMenus.forEach(dropdown => {
      const slideContainer = dropdown.querySelector('.mobile-slide-container');
      if (slideContainer) {
        const originalChildNav = slideContainer.querySelector('.child-nav');
        if (originalChildNav) {
          slideContainer.parentNode.replaceChild(originalChildNav.cloneNode(true), slideContainer);
        } else {
          slideContainer.remove();
        }
      }

      const existingPanel = dropdown.querySelector('.sidebar-submenu-panel');
      if (existingPanel) {
        existingPanel.remove();
      }

      const disclosurePanels = dropdown.querySelectorAll('.disclosure__panel');
      disclosurePanels.forEach(panel => {
        panel.style.display = '';
      });

      const navMenus = dropdown.querySelectorAll('nav-menu details');
      navMenus.forEach(navMenu => {
        navMenu.style.pointerEvents = '';
      });

      this.removeAllActiveStates(dropdown);
      this.removeEventListeners(dropdown);
    });
    
    this.slideStack = [];
  }

  initializeDesktopDropdown(dropdown) {
    if (this.isMobile) return;

    const existingPanel = dropdown.querySelector('.sidebar-submenu-panel');
    if (existingPanel) {
      existingPanel.remove();
    }

    const rightPanel = this.createRightPanel();
    dropdown.appendChild(rightPanel);
    
    const categoryItems = dropdown.querySelectorAll('.child-nav > li:nth-child(n+3)');
    
    categoryItems.forEach((item, index) => {
      this.setupCategoryItem(item, categoryItems, rightPanel);
    });
    
    this.setupDropdownEvents(dropdown, categoryItems, rightPanel);
  }

  createRightPanel() {
    const rightPanel = document.createElement('div');
    rightPanel.className = 'sidebar-submenu-panel';
    rightPanel.innerHTML = '';
    rightPanel.style.display = 'none';
    return rightPanel;
  }

  setupCategoryItem(item, categoryItems, rightPanel) {
    if (this.isMobile) return;

    const toggle = item.querySelector('.child-nav__item--toggle');
    const navMenu = item.querySelector('nav-menu');
    const panel = navMenu ? navMenu.querySelector('.disclosure__panel') : null;
    
    if (toggle) {
      toggle.removeEventListener('mouseenter', this.handleCategoryHoverBound);
      toggle.removeEventListener('click', this.handleCategoryClickBound);
      
      this.handleCategoryHoverBound = () => {
        this.handleCategoryHover(toggle, categoryItems, panel, rightPanel);
      };
      
      this.handleCategoryClickBound = (e) => {
        this.handleCategoryClick(e, toggle, rightPanel);
      };
      
      toggle.addEventListener('mouseenter', this.handleCategoryHoverBound);
      toggle.addEventListener('click', this.handleCategoryClickBound);
    }
  }

  handleCategoryHover(targetElement, categoryItems, panel, rightPanel) {
    if (this.isMobile) return;

    this.removeActiveStates(categoryItems);
    targetElement.classList.add('active');
    this.updateRightPanel(panel, targetElement, rightPanel);
  }

  handleCategoryClick(e, targetElement, rightPanel) {
    if (this.isMobile) return;
    
    const categoryLink = targetElement.getAttribute('data-category-url');
    if (categoryLink) {
      if (targetElement.classList.contains('child-nav__item--toggle')) {
        e.preventDefault();
      }
      window.location.href = categoryLink;
    }
  }

  updateRightPanel(panel, targetElement, rightPanel) {
    const hasContent = panel && 
                      panel.innerHTML.trim() && 
                      panel.querySelector('.main-nav__grandchild') && 
                      panel.querySelector('.main-nav__grandchild').children.length > 0;
    
    if (hasContent) {
      rightPanel.style.display = 'flex';
      rightPanel.innerHTML = panel.innerHTML;
      
      const grandchildList = rightPanel.querySelector('.main-nav__grandchild');
      if (grandchildList) {
        this.setupGrandchildList(grandchildList);
      }
      
      // Hide fourth level indicators on desktop
      const fourthLevelIndicators = rightPanel.querySelectorAll('.fourth-level-indicator');
      fourthLevelIndicators.forEach(indicator => {
        indicator.style.display = 'none';
      });
    } else {
      rightPanel.style.display = 'none';
      rightPanel.innerHTML = '';
    }
  }

  setupGrandchildList(grandchildList) {
    // On desktop, fourth level items should behave as regular links
    const fourthLevelToggles = grandchildList.querySelectorAll('[data-has-fourth-level="true"]');
    fourthLevelToggles.forEach(toggle => {
      const link = toggle.querySelector('a');
      if (link) {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = link.href;
        });
      }
    });
  }

  setupDropdownEvents(dropdown, categoryItems, rightPanel) {
    if (this.isMobile) return;

    dropdown.removeEventListener('mouseleave', this.dropdownMouseLeaveBound);
    rightPanel.removeEventListener('mouseleave', this.rightPanelMouseLeaveBound);

    this.dropdownMouseLeaveBound = () => {
      this.resetActiveStates(categoryItems, rightPanel);
    };

    this.rightPanelMouseLeaveBound = (e) => {
      if (!dropdown.contains(e.relatedTarget)) {
        this.resetActiveStates(categoryItems, rightPanel);
      }
    };

    dropdown.addEventListener('mouseleave', this.dropdownMouseLeaveBound);
    rightPanel.addEventListener('mouseleave', this.rightPanelMouseLeaveBound);
  }

  removeActiveStates(categoryItems) {
    categoryItems.forEach(item => {
      const target = item.querySelector('.child-nav__item--toggle') || 
                    item.querySelector('.child-nav__item');
      if (target) {
        target.classList.remove('active');
      }
    });
  }

  removeAllActiveStates(dropdown) {
    const allActiveElements = dropdown.querySelectorAll('.active');
    allActiveElements.forEach(element => {
      element.classList.remove('active');
    });
  }

  removeEventListeners(dropdown) {
    const categoryItems = dropdown.querySelectorAll('.child-nav > li:nth-child(n+3)');
    categoryItems.forEach(item => {
      const toggle = item.querySelector('.child-nav__item--toggle');
      if (toggle) {
        if (this.handleCategoryHoverBound) {
          toggle.removeEventListener('mouseenter', this.handleCategoryHoverBound);
        }
        if (this.handleCategoryClickBound) {
          toggle.removeEventListener('click', this.handleCategoryClickBound);
        }
        if (this.handleMobileSlideClickBound) {
          toggle.removeEventListener('click', this.handleMobileSlideClickBound);
        }
      }
    });

    if (this.dropdownMouseLeaveBound) {
      dropdown.removeEventListener('mouseleave', this.dropdownMouseLeaveBound);
    }

    const rightPanel = dropdown.querySelector('.sidebar-submenu-panel');
    if (rightPanel && this.rightPanelMouseLeaveBound) {
      rightPanel.removeEventListener('mouseleave', this.rightPanelMouseLeaveBound);
    }
  }

  resetActiveStates(categoryItems, rightPanel) {
    this.removeActiveStates(categoryItems);
    rightPanel.style.display = 'none';
    rightPanel.innerHTML = '';
  }

  setupResizeHandler() {
    const handleResize = this.debounce(() => {
      const wasMobile = this.isMobile;
      this.checkMobileState();
      
      if (wasMobile !== this.isMobile) {
        this.setupSidebarMenus();
      }
    }, 250);
    
    window.addEventListener('resize', handleResize);
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  getCategoryName(targetElement) {
    const categoryLink = targetElement.querySelector('a') || targetElement;
    return categoryLink.textContent.trim().replace('›', '').replace(/\s+/g, ' ');
  }
}

new SidebarMenuManager();